import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  auditLogs: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
});

const auditLogsModule = {
  namespaced: true,
  state: initState(),
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SET_AUDIT_LOGS: (s, data) => {
      s.auditLogs = data.auditLogs;
      s.pagination = data.pagination;
    },
    RESET_STATE: (s) => {
      Object.assign(s, initState());
    },
  },

  actions: {
    async getAuditLogs({ commit }, params) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/audit-logs", {
          params,
        });
        const { data, pagination } = res.data;
        commit("SET_AUDIT_LOGS", { auditLogs: data, pagination });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
  },
};
export default auditLogsModule;
